import React, {Component}  from 'react';
import { Link } from 'react-router-dom';
import Api from '../util/Api';
import dateFormat from "dateformat";
import * as Loader from "react-loader-spinner";
import ProgressiveImage from 'react-progressive-graceful-image';

class TFourth extends Component{
    constructor(props){
      super(props)
  
      this.state = {
        loading: true,
        response: [],
        head: props.head,
        query: props.q,
        category: props.category,
        dataRes: 0,
        firstInitSize: props.q.split("|")[1]
      }
      this.getData();
    }

    componentDidMount(){
        // setTimeout(() => {
            this.setState({
                loading: false
            });
        // }, 500);
    }

    loadMoreData(e){
        e.preventDefault()
        let uri = "/article"+this.state.category+"/home";
        const postData = {
            query: this.state.dataRes+"|10"
        };
        Api(uri, postData).then(res => {
            var size = 0;
            if(res.length >= 10){
                size = this.state.dataRes+res.length
            }
            this.setState({
                response: this.state.response.concat(res),
                dataRes: size
            },() => {});
        })
        .catch(err => console.log(err));
    }
    
    getData(){
        let uri = "/article"+this.state.category+"/home";
        const postData = {
            query: this.state.query
        };
        Api(uri, postData).then(res => {
            var size = 0;
            if(res.length >= 10){
                size = this.state.dataRes+res.length
            }
            this.setState({
                response: res,
                dataRes: size
            });
        })
        .catch(err => console.log(err));
    }

    render(){
        let state = this.state;
        let dataRes = state.response;
        // let res = state.response;
        const data = state.loading === true ?
        (
        <div className='col-lg-12 text-center'>
            <Loader.ProgressBar type="ThreeDots" color="#F00F00" height="100%" width="10%" />
        </div>
        )
        :
        (
            <div className='col-lg-12 text-left'>
                <div className='row title-template'>
                    <div className='col head'>{state.head}</div>
                    <div className='col read-more text-right'>
                        {window.location.pathname === "/" ? (
                            <Link reloadDocument to={this.state.category}>Read More</Link>
                        ) : (<></>)}
                    </div>
                </div>
                <div className='row'>
                    {dataRes.map((res,i) =>  (
                    <div className='col-md-12' key={i}>
                        {/* <Link reloadDocument to={{pathname: '/page/'+res.category+'/'+res.title.replace(/\s+/g, '-').toLowerCase()+''}}> */}
                        <Link reloadDocument to={{pathname: '/page/'+res.category+'/'+res.titleUrl}}>
                            <div className='row content'>
                                <div className='col-md-4 col-sm-3 text-center'>
                                    {/* <img src={res.imageUrl === "" ? "/./images/default.jpg" : res.imageUrl} alt='' className=' img-fluid'/> */}
                                    <ProgressiveImage
                                        delay={500}
                                        src={res.imageUrl === "" ? "/./images/default.jpg" : res.imageUrl}
                                        placeholder="/./images/default.jpg"
                                        >
                                            {(src) => <img src={src} alt="" className={"img-fluid"} />}
                                    </ProgressiveImage>
                                </div>
                                
                                {/* <div className='col text-right'>
                                    <i className='icon fa-regular fa-comment'></i>
                                    0
                                </div> */}
                                <div className='col-md-8 col-sm-9'>
                                    <div className='row content-date d-sm-block d-xs-block d-xxl-none d-xl-none d-md-none'>
                                        <div className='col'>
                                            <i className='icon fa-regular fa-clock'></i>
                                            {dateFormat(res.createdAt, "mmm dd, yyyy HH:MM:ss")}
                                        </div>
                                        {/* <div className='col text-right'>
                                            <i className='icon fa-regular fa-comment'></i>
                                            0
                                        </div> */}
                                    </div>
                                    <div className='row'>
                                        <div className='col'>
                                            <h5><b className=''>{res.title}</b></h5>
                                        </div>
                                    </div>
                                    <div className='row content-date d-xxl-block d-xl-block d-md-block d-none d-sm-none'>
                                        <div className='col'>
                                            <i className='icon fa-regular fa-clock'></i>
                                            {dateFormat(res.createdAt, "mmm dd, yyyy HH:MM:ss")}
                                        </div>
                                        {/* <div className='col text-right'>
                                            <i className='icon fa-regular fa-comment'></i>
                                            0
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                    ))}
                </div>
                {window.location.pathname !== "/" ? (
                    <div className='my-3 text-center'>
                        <div className='col-md-3 col-sm-12 btn btn-md btn-danger' onClick={(e) => {this.loadMoreData(e)}}>More</div>
                    </div>
                ):(<></>)}
            </div>
        );
        return (
            <div className='row template-4'>
                {data}
            </div>
        )
    }
}

export default TFourth;